interface IDateFormat {
  [key: string]: {
    en: string;
    kn: string;
  };
}
const dateFormatter = (date: string) => {
  const dateObj = new Date(date);
  const month = monthMapper[dateObj.getMonth()];
  const year = dateObj.getFullYear();
  const dateString = dateObj.getDate();
  return `${dateString} ${month}, ${year}`;
};

const monthMapper = [
  "January",
  "Feburary",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const monthDataFormat: IDateFormat = {
  JANUARY: { en: "January", kn: "ಜನವರಿ" },
  FEBRUARY: { en: "February", kn: "ಫೆಬ್ರವರಿ" },
  MARCH: { en: "March", kn: "ಮಾರ್ಚ್" },
  APRIL: { en: "April", kn: "ಏಪ್ರಿಲ್" },
  MAY: { en: "May", kn: "ಮೇ" },
  JUNE: { en: "June", kn: "ಜೂನ್" },
  JULY: { en: "July", kn: "ಜುಲೈ" },
  AUGUST: { en: "August", kn: "ಆಗಸ್ಟ್" },
  SEPTEMBER: { en: "September", kn: "ಸೆಪ್ಟೆಂಬರ್" },
  OCTOBER: { en: "October", kn: "ಅಕ್ಟೋಬರ್" },
  NOVEMBER: { en: "November", kn: "ನವೆಂಬರ್" },
  DECEMBER: { en: "December", kn: "ಡಿಸೆಂಬರ್" },
};


export default dateFormatter;

export const isAnySucceesPayment = (transactions) => {
  const hasSuccess = transactions.some(
    (transaction) => transaction.status === "SUCCESS"
  );
  return hasSuccess;
};
